import i18next from "i18next";
import { Modal } from "react-bootstrap";
import { UserDocument } from "src/api/models/UserDTO";

type Props = {
  isOpen?: boolean;
  closePreview: () => void;
  document?: UserDocument & {
    url: string;
  }
};

export default function ReporterFilePreviewModal({ isOpen, closePreview, document }: Props) {
  if (!document) return null;

  const url = 'https://mozilla.github.io/pdf.js/legacy/web/viewer.html?file=' + encodeURIComponent(document.url);

  return (
    <Modal show={isOpen} size="xl">
      <Modal.Header closeButton onClick={closePreview}>
        <Modal.Title>{document.fileName}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <object
          style={{ height: '80vh', width: '100%' }}
          data={url}
          type="application/pdf">
          <p>{i18next.t('file_preview_error')}</p>
        </object>
      </Modal.Body>
    </Modal>
  )
}
